import { API_BASE, request } from './client';

// GET /api/site — everything the page renders. Returns null when no backend is configured.
export async function fetchSite({ signal } = {}) {
  if (!API_BASE) return null;
  return request(`${API_BASE}/api/site`, { signal });
}
